import { useCallback, useState } from 'react';
import _ from 'lodash';

import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const useDebouncedState = ({ initialValue, timeout = 300, onDebounce = _.noop }) => {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useUpdateEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
      onDebounce(value);
    }, timeout);

    return () => clearTimeout(timeoutId);
  }, [value]);

  const handleReset = useCallback(() => {
    setValue(initialValue);
    setDebouncedValue(initialValue);
  }, [initialValue]);

  return {
    value,
    debouncedValue,
    setValue,
    reset: handleReset
  };
};

export default useDebouncedState;
